
//TL_FOR_RUBY-4959 アプリページ更新：カルーセルの挙動対応（SPのみ）

(function () {
    var track = document.getElementById('featSpTrack');
    if (!track) return;
  
    var slides = track.children;
    var dots   = document.querySelectorAll('.feat-sp__dots button');
    var prev   = document.querySelector('.feat-sp__nav.is-prev');
    var next   = document.querySelector('.feat-sp__nav.is-next');
    var current = 0;
  
    function clamp(i) {
      var max = slides.length - 1;
      if (i < 0) return 0;
      if (i > max) return max;
      return i;
    }
  
    function updateDots() {
      current = clamp(Math.round(track.scrollLeft / track.clientWidth));
  
      for (var j = 0; j < dots.length; j++) {
        if (j === current) dots[j].classList.add('is-active');
        else dots[j].classList.remove('is-active');
      }
  
      if (prev) prev.style.visibility = current === 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = current === slides.length - 1 ? 'hidden' : 'visible';
    }
  
    function goTo(i, smooth) {
      current = clamp(i);
      var left = current * track.clientWidth;
      try {
        track.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
      } catch (e) {
        track.scrollLeft = left;
      }
      updateDots();
    }
  
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
  
    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { goTo(idx); });
      })(i);
    }
  
    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(updateDots, 80);
    });
  
    updateDots();
  })();
  